import React from "react";
import Dropzone from "react-dropzone";
import { Checkbox, RaisedButton, CircularProgress } from "material-ui";
import { Table } from "reactable";
import moment from "moment";
import twix from "twix";
import striptags from "striptags";

import connectToStores from "alt-utils/lib/connectToStores";
import BulkImportActions from "../actions/BulkImportActions";
import BulkImportStore from "../stores/BulkImportStore";

import InfoNotice from "./partials/info-notice.jsx";

import CheckCircleIcon from "material-ui/svg-icons/action/check-circle";
import ErrorIcon from "material-ui/svg-icons/alert/error";

import config from "../config";
import InjectedSelect from "./partials/injected-select.jsx";
import Label from "./partials/label.jsx";
import QuillEditor from "./partials/quill-editor.jsx";
import LinkLike from "./partials/link-like.jsx";

import { formatPrice, capitalize } from "../util";

const TABLE_COLUMNS = [
  { key: "name", label: "Title" },
  { key: "description", label: "Description" },
  { key: "short_description", label: "Short" },
  { key: "tag_names", label: "Tags" },
  { key: "details", label: "Details" },
  { key: "credits", label: "Credits" },
  { key: "visibility", label: "Visibility" },
  { key: "images", label: "Images" }
];

class BulkImportFilms extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      csvFile: null,
      userReadyToImport: false
    };

    this.reset = this.reset.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.import = this.import.bind(this);
  }

  static getStores() {
    return [BulkImportStore];
  }

  static getPropsFromStores() {
    return BulkImportStore.getState();
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      progressContainer: {
        margin: "0 auto",
        textAlign: "center",
        padding: 10
      },
      icon: {
        width: 80,
        height: "auto",
        color: "rgb(2, 136, 209)"
      },
      message: {
        marginTop: 10
      },
      dropzone: {
        padding: 20,
        lineHeight: "1.25",
        padding: 10,
        border: "1px dashed #ccc",
        cursor: "pointer"
      },
      actions: {
        marginTop: 10
      },
      previewExtraMessage: {
        padding: 20,
        border: "1px dashed #ccc"
      }
    };
  }

  componentWillMount() {
    this.reset();
  }

  reset() {
    this.setState({
      csvFile: null,
      userReadyToImport: false
    });
    BulkImportActions.reset.defer();
  }

  onDrop(files) {
    if (!files.length) {
      return;
    }
    this.setState({
      csvFile: files[0]
    });
  }

  import() {
    BulkImportActions.importFilms({
      eventBucket: this.props.params.eventBucketId,
      csvFile: this.state.csvFile,
      preview: !this.state.userReadyToImport
    });
    window.scrollTo(0, 0);
  }

  _makeCsvLink() {
    return config.endpoint + "bulk_import/example/films";
  }

  _makeTable(films) {
    return (
      <Table
        className={"bordered striped responsive-table"}
        columns={TABLE_COLUMNS}
        data={films.map(f =>
          Object.assign({}, f, {
            short_description: f.short_description && (
              <span title={f.short_description}>
                {f.short_description.substring(0, 10).trim() + "..."}
              </span>
            ),
            description: f.description && (
              <span title={striptags(f.description)}>
                {striptags(f.description)
                  .substring(0, 10)
                  .trim() + "..."}
              </span>
            ),
            tag_names: f.tags.map(t => t.name).join(", "),
            details: Object.entries(f.details || {})
              .map(([k, v]) => `${capitalize(k)}: ${v}`)
              .join("; "),
            credits: Object.entries(f.credits || {})
              .map(([k, v]) => `${capitalize(k)}: ${v}`)
              .join("; "),
            visibility: capitalize(f.visibility),
            images: (
              <span>
                {f.poster_image ? (
                  <span>
                    Poster:{" "}
                    <img
                      src={f.poster_image.poster.url}
                      style={{ height: 40 }}
                    />
                  </span>
                ) : null}{" "}
                {f.cover_image ? (
                  <span>
                    Cover:{" "}
                    <img src={f.cover_image.cover.url} style={{ height: 40 }} />
                  </span>
                ) : null}
              </span>
            )
          })
        )}
      />
    );
  }

  render() {
    let {
        isImporting,
        importCompleted,
        importSuccessful,
        importMessage,
        previewData
      } = this.props,
      styles = this.getStyles();

    if (isImporting || (importCompleted && !previewData)) {
      return (
        <div style={styles.progressContainer}>
          {isImporting ? (
            <CircularProgress size={1.5} mode="indeterminate" />
          ) : importSuccessful ? (
            <CheckCircleIcon style={styles.icon} />
          ) : (
            <ErrorIcon style={styles.icon} />
          )}
          <div style={styles.message}>
            {isImporting ? (
              <div>
                {this.state.userReadyToImport ? "Importing" : "Previewing"}{" "}
                films...
                <br />
                This may take a little while.
              </div>
            ) : (
              importMessage
            )}
            {!isImporting ? (
              <div>
                {importSuccessful && (
                  <span>
                    <LinkLike
                      onTouchTap={() =>
                        this.context.router.push(
                          `/event_buckets/${this.props.params.eventBucketId}/films`
                        )
                      }
                    >
                      view film list
                    </LinkLike>{" "}
                    |{" "}
                  </span>
                )}
                <LinkLike onTouchTap={this.reset}>restart</LinkLike>
              </div>
            ) : null}
          </div>
        </div>
      );
    }

    if (previewData && this.state.csvFile) {
      return (
        <div>
          <p>
            We detected {previewData.films.length} film
            {previewData.films.length !== 1 ? "s" : ""} in your uploaded data.
            Have a look:
          </p>
          {this._makeTable(previewData.films)}
          {previewData.tags.length ? (
            <p>
              We also detected {previewData.tags.length} new tag
              {previewData.tags.length !== 1 ? "s" : ""} in your data, so{" "}
              {previewData.tags.length !== 1 ? "they" : "it"} will automatically
              be created when importing.
              <br />
              <i>
                You can edit tag colors, names, and more after importing (in the
                Tags section).
              </i>
              <ul>
                {previewData.tags.map(t => (
                  <li key={t.name}>{t.name}</li>
                ))}
              </ul>
            </p>
          ) : null}
          <p>
            If everything looks all right, confirm & start the import.
            Otherwise,{" "}
            <LinkLike onTouchTap={this.reset}>edit settings</LinkLike>.
          </p>
          <div>
            <Checkbox
              label={`Yes, I'm ready to import ${
                previewData.films.length
              } film${previewData.films.length !== 1 ? "s" : ""}.`}
              checked={this.state.userReadyToImport}
              onCheck={() =>
                this.setState({
                  userReadyToImport: !this.state.userReadyToImport
                })
              }
            />
          </div>
          <div style={styles.actions}>
            <RaisedButton
              label="Start import"
              primary={true}
              disabled={!this.state.userReadyToImport}
              onTouchTap={this.import}
            />
          </div>
        </div>
      );
    }

    return (
      <div>
        <h1>Bulk import films</h1>
        <InfoNotice style={{ marginTop: 20 }}>
          Check out our{" "}
          <a
            href="https://help.eventive.org/films/bulk-import-films"
            target="_blank"
          >
            guide to importing films
          </a>
          .
        </InfoNotice>
        <p>
          Use this wizard to create films in bulk. Just download the Excel
          template, fill in your data, and upload.
          <br />
          <i>
            Detailed explanations of what to include in each column are included
            in our{" "}
            <a
              href="https://help.eventive.org/films/bulk-import-films"
              target="_blank"
            >
              guide to importing films
            </a>
            .
          </i>
        </p>
        <div>
          <Label>
            Add spreadsheet (
            <a target="_blank" href={this._makeCsvLink()}>
              download template
            </a>
            )
          </Label>
          <Dropzone
            style={styles.dropzone}
            multiple={false}
            onDrop={this.onDrop}
          >
            {({ isDragActive, isDragReject, acceptedFiles, rejectedFiles }) => {
              return isDragActive ? (
                "Release to select."
              ) : acceptedFiles.length ? (
                <span>
                  One spreadsheet <i>({acceptedFiles[0].name})</i> ready to
                  import.
                </span>
              ) : (
                "Drop spreadsheet here, or click to select."
              );
            }}
          </Dropzone>
        </div>
        <div style={styles.actions}>
          <RaisedButton
            label="Preview import..."
            primary={true}
            disabled={!this.state.csvFile}
            onTouchTap={this.import}
          />
        </div>
      </div>
    );
  }
}

export default connectToStores(BulkImportFilms);



// WEBPACK FOOTER //
// ./src/app/components/bulk-import-films.jsx